import ResumeImg from "../assets/resume.jpg";
export default function Resume() {
  const config = {
    link: 'https://drive.google.com/file/d/1_K1nfpJdSWgXjXVwnBf9YBGsg2T7SrBc/view'
  }
  return (
    <section id="resume" className=" flex flex-col md:flex-row  py-20 bg-white text-black about-all">
      <div className=" md:w-1/2 abt-img flex justify-center">
        <img className="w-[400px] " src={ResumeImg} alt="About" />
      </div>
      <div className=" about-ct font-hero-font flex-col  justify-center">
        <h2 className="text-4xl  font-bold mb-5">Resume</h2>
        <h6 className="font-bold">A story of hard work and perseverance.</h6>
        <p>You can view my resume here</p>
        <div className="md:flex-row align-center py-5 space-x-5 Hero-btns">
             <button><a href={config.link} target='_blank'>Download CV</a></button>
        </div>
      </div>
    </section>
  );
}
